<template>
	<div class="page">
		<Tip :title="title" />
		<div class="from_div">
            <div style="max-height: 60vh;overflow-y: scroll;text-align: left;">
                <div>1、请线下发货后，手动填写订单对应的发货单号</div>
                <div>2、在基本设置页配置快递100平台账号和充值后，一键接口下物流发货单，并返回单号</div>
                <div>3、快递单号为选填，确定发货后该订单状态将变更为已发货状态</div>
            
                <div style="margin-top: 10px;">
                    快递公司：
                    <el-select v-model="express_sn" filterable placeholder="请选择">
                        <el-option v-for="(item, ei) in expressLists" :key="ei" :label="item.express_name" :value="item.express_sn" ></el-option>
                    </el-select>
                </div>
            
                <el-table :data="arr" style="width: 100%;" ref="sendTableRef">
                    <el-table-column min-width="200" label="订单单号">
                        <template slot-scope="scope">
                            <div>{{scope.row.order_no}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="300" label="收货信息">
                        <template slot-scope="scope">
                            <div>
                                <div>{{scope.row.receive_name}} {{scope.row.receive_phone}}</div>
                                <div>{{scope.row.receive_province}} {{scope.row.receive_city}} {{scope.row.receive_area}} {{scope.row.receive_street}} {{scope.row.receive_address}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="200" label="订单商品">
                        <template slot-scope="scope">
                            <div v-for="(orderGood, gindex) in scope.row.order_good_arr">
                                <div><span class="label-color">名称: </span>{{orderGood.good_name}}</div>
                                <div>
                                    <span class="label-color">规格: </span>{{orderGood.spec_data_str}} 
                                    <span class="label-color">金额: </span>{{orderGood.sale_price}} X {{orderGood.quatity}}
                                </div>
                                <div><span class="label-color">供货: </span>{{orderGood.good_source_text}} <span class="label-color">类型: </span>{{orderGood.good_type_text}}</div>
                                <el-divider v-if="scope.row.order_good_arr.length > 1"></el-divider>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="220" label="快递单号">
                        <template slot-scope="scope">
                            <div v-for="(orderGood, gindex) in scope.row.order_good_arr" :key="gindex">
                                <el-input v-model="orderGood.express_no" placeholder="" clearable minlength="1" maxlength="200" style="width: 200px;"></el-input>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
            <!-- <el-button type="warning" @click="close">一键快递接口发货</el-button>
            <el-button type="primary" @click="close">打印面单</el-button> -->
			<el-button type="primary" @click="submitForm()">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
    import {
		orderExpress,
		orderSend
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
        props: {
			arr: {
				type: Array
			}
		},
		data() {
			return {
				title: '批量发货',
                expressLists: [],
                express_sn: '',
			}
		},
		mounted() {
            console.log('发货订单', this.arr)
            this.getOrderExpress();
        },
		methods: {
			getOrderExpress(){
				orderExpress().then(res=>{
					if(res.code == 0){
                        this.expressLists = res.data;
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err=>{})
			},

            //提交表单
			submitForm() {
                if(!this.express_sn){
                    return this.$message({ type: 'error', message: '请选择快递公司!' });
                }

                var orderExpress = [];  // {"order_id": 4, "order_good_id": 13, "express_no": "123456"}
                this.arr.forEach((row, rowindex) => {
                    row.order_good_arr.forEach((subrow, subrowindex) => {
                        if(subrow.express_no){
                            orderExpress.push({order_id: subrow.order_id, order_good_id: subrow.order_good_id, express_no: subrow.express_no});
                        }
                    });
                });
                if(!orderExpress.length){
                    return this.$message({ type: 'error', message: '请填写快递单号!' });
                }

                var params = {
                    express_sn: this.express_sn,
                    orderExpress
                };
                orderSend(params).then(res => {
                    if (res.code == 0) {
                        this.$message({ type: 'success', message: res.msg || '发货成功!' });
                        this.$emit('close', 1)
                    }else{
                        console.log('submit error', params)
                        return this.$message({ type: 'error', message: res.msg });
                    }
                }).catch(err => {})
			},

			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 570px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
		margin-right: 20px;
	}

    .long-input {
        width: 420px;
    }

	.select {
		width: 137px;
		margin-right: 20px;
	}
	
	.picker {
		width: 420px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>